import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { geocode: '_addressLocation' };
var _addressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _availabilityException = {
    startTime: 'google.protobuf.Timestamp',
    endTime: 'google.protobuf.Timestamp',
};
var _bulkUpdateOperationTagsByFilterRequest = {};
var _bulkUpdateOperationTagsByFilterResponse = {};
var _bulkUpdateOperationTagsRequest = {};
var _bulkUpdateOperationTagsResponse = {};
var _businessLocationDetails = { address: '_v1Address' };
var _createOperationRequest = { operation: '_operation' };
var _createOperationResponse = { operation: '_operation' };
var _deleteOperationRequest = {};
var _deleteOperationResponse = {};
var _firstFulfillmentTimeSlotsPerMenu = {
    timeslotsPerFulfillmentType: '_fulfillmentTimeSlot',
};
var _fulfillmentAddress = { address: '_address' };
var _fulfillmentOption = {
    pickupOptions: '_pickupDetails',
    availability: '_fulfillmentOptionAvailability',
};
var _fulfillmentOptionAvailability = {
    startTime: 'google.protobuf.Timestamp',
    endTime: 'google.protobuf.Timestamp',
    exceptions: '_availabilityException',
};
var _fulfillmentTimeSlot = {
    startTime: 'google.protobuf.Timestamp',
    endTime: 'google.protobuf.Timestamp',
    fulfillmentAddress: '_fulfillmentAddress',
};
var _getExpectedFulfillmentSelectionRequest = {
    timeslotStartTime: 'google.protobuf.Timestamp',
    timeslotEndTime: 'google.protobuf.Timestamp',
    deliveryAddress: '_address',
};
var _getExpectedFulfillmentSelectionResponse = {
    expectedFulfillmentSelections: '_fulfillmentOption',
};
var _getOperationRequest = {};
var _getOperationResponse = { operation: '_operation' };
var _listAvailableDatesInRangeRequest = { deliveryAddress: '_address' };
var _listAvailableDatesInRangeResponse = {};
var _listAvailableFulfillmentOptionsRequest = { deliveryAddress: '_address' };
var _listAvailableFulfillmentOptionsResponse = {
    fulfillmentOptions: '_fulfillmentOption',
};
var _listAvailableTimeSlotsForDateRequest = { deliveryAddress: '_address' };
var _listAvailableTimeSlotsForDateResponse = {
    timeSlots: '_fulfillmentTimeSlot',
};
var _listFirstAvailableTimeSlotForFulfillmentTypesRequest = {
    deliveryAddress: '_address',
};
var _listFirstAvailableTimeSlotForFulfillmentTypesResponse = {
    timeSlots: '_fulfillmentTimeSlot',
};
var _listFirstAvailableTimeSlotsForMenusRequest = {
    deliveryAddress: '_address',
};
var _listFirstAvailableTimeSlotsForMenusResponse = {
    timeSlotsPerMenu: '_firstFulfillmentTimeSlotsPerMenu',
};
var _listFirstAvailableTimeSlotsForOperationsRequest = {
    deliveryAddress: '_address',
};
var _listFirstAvailableTimeSlotsForOperationsResponse = {
    timeSlots: '_operationTimeSlot',
};
var _listOperationIdsRequest = {};
var _listOperationIdsResponse = {};
var _listOperationsInternalRequest = {};
var _listOperationsInternalResponse = { operations: '_operation' };
var _listOperationsRequest = {};
var _listOperationsResponse = { operations: '_operation' };
var _onlineOrderingPausedUntilOptions = { time: 'google.protobuf.Timestamp' };
var _operation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    pausedUntilOptions: '_onlineOrderingPausedUntilOptions',
    businessLocationDetails: '_businessLocationDetails',
};
var _operationTimeSlot = { timeSlots: '_fulfillmentTimeSlot' };
var _pickupDetails = { address: '_address' };
var _queryOperationRequest = {};
var _queryOperationResponse = { operations: '_operation' };
var _updateOperationRequest = {
    mask: 'google.protobuf.FieldMask',
    operation: '_operation',
};
var _updateOperationResponse = { operation: '_operation' };
var _v1Address = { geocode: '_v1AddressLocation' };
var _v1AddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _validateOperationAddressRequest = {};
var _validateOperationAddressResponse = {};
function resolveWixRestaurantsOperationsV1OperationsServiceUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants-operations/v1',
                destPath: '/v1',
            },
            {
                srcPath: '/restaurants/operations/v1/operations',
                destPath: '/v1/operations',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        _base_domain_: [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'users._base_domain_': [
            {
                srcPath: '/_api/restaurants-operations/v1',
                destPath: '/v1',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-operations',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a new operation. */
export function createOperation(payload) {
    var _a = serializer(_createOperationRequest, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createOperationResponse, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }).fromJSON;
    function __createOperation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'POST',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.CreateOperation',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createOperation.fromReq = fromReq;
    __createOperation.__isAmbassador = true;
    return __createOperation;
}
/** Retrieves an operation. */
export function getOperation(payload) {
    var _a = serializer(_getOperationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getOperationResponse, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }).fromJSON;
    function __getOperation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.GetOperation',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getOperation.fromReq = fromReq;
    __getOperation.__isAmbassador = true;
    return __getOperation;
}
/**
 * Updates an operation.
 *
 * If you update part of the `orderScheduling` property, the whole object is overwritten,
 * so you must include the entire object unless you are not updating `orderScheduling` at all. <br />
 *
 * Each time the operation is updated,
 * `revision` increments by 1.
 * The current `revision` must be passed when updating the operation.
 * This ensures you're working with the latest operation
 * and prevents unintended overwrites.
 */
export function updateOperation(payload) {
    var _a = serializer(_updateOperationRequest, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateOperationResponse, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }).fromJSON;
    function __updateOperation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'PATCH',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.UpdateOperation',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operation.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateOperation.fromReq = fromReq;
    __updateOperation.__isAmbassador = true;
    return __updateOperation;
}
/** Deletes an operation. */
export function deleteOperation(payload) {
    var _a = serializer(_deleteOperationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteOperationResponse, {}).fromJSON;
    function __deleteOperation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.DeleteOperation',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteOperation.fromReq = fromReq;
    __deleteOperation.__isAmbassador = true;
    return __deleteOperation;
}
/**
 * Retrieves a list of operations, given the provided paging, filtering, and sorting.
 *
 * Query Operation runs with these defaults, which you can override:
 *
 * - `paging.limit` is `50`
 * - `sort.order` is `ASC`
 *
 * For field support for filters and sorting,
 * see [Operations: Supported Filters and Sorting](https://dev.wix.com/docs/rest/api-reference/wix-restaurants/operations/operation-v1/supported-filters-and-sorting).
 *
 * To learn about working with _Query_ endpoints, see
 * [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language),
 * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/getting-started/sorting-and-paging),
 * and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function queryOperation(payload) {
    var _a = serializer(_queryOperationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryOperationResponse, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }).fromJSON;
    function __queryOperation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'POST',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.QueryOperation',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryOperation.fromReq = fromReq;
    __queryOperation.__isAmbassador = true;
    return __queryOperation;
}
/**
 * Retrieves a list of operations.
 * The result will be sorted by created date in ascending order.
 */
export function listOperations(payload) {
    var _a = serializer(_listOperationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOperationsResponse, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }).fromJSON;
    function __listOperations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListOperations',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOperations.fromReq = fromReq;
    __listOperations.__isAmbassador = true;
    return __listOperations;
}
export function listOperationIds(payload) {
    var _a = serializer(_listOperationIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOperationIdsResponse, {}).fromJSON;
    function __listOperationIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListOperationIds',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/ids',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOperationIds.fromReq = fromReq;
    __listOperationIds.__isAmbassador = true;
    return __listOperationIds;
}
export function listOperationsInternal(payload) {
    var _a = serializer(_listOperationsInternalRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listOperationsInternalResponse, {
        _businessLocationDetails: _businessLocationDetails,
        _onlineOrderingPausedUntilOptions: _onlineOrderingPausedUntilOptions,
        _operation: _operation,
        _v1Address: _v1Address,
        _v1AddressLocation: _v1AddressLocation,
    }).fromJSON;
    function __listOperationsInternal(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListOperationsInternal',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/internal',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listOperationsInternal.fromReq = fromReq;
    __listOperationsInternal.__isAmbassador = true;
    return __listOperationsInternal;
}
/**
 * Retrieves a list of available fulfillment options.
 *
 * What makes a fulfillment option available is whether you can submit an order given the scheduling configurations and the fulfillment method's availability.
 * When a delivery address is not provided in the input, our system retrieves a list encompassing all types of fulfillment methods.
 * Conversely, if a delivery address` is given, the response may includes non-delivery fulfillment options along with delivery fulfillment methods that are applicable to the given address, ensuring the address falls within the defined delivery area of these methods.
 */
export function listAvailableFulfillmentOptions(payload) {
    var _a = serializer(_listAvailableFulfillmentOptionsRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAvailableFulfillmentOptionsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availabilityException: _availabilityException,
        _fulfillmentOption: _fulfillmentOption,
        _fulfillmentOptionAvailability: _fulfillmentOptionAvailability,
        _pickupDetails: _pickupDetails,
    }).fromJSON;
    function __listAvailableFulfillmentOptions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListAvailableFulfillmentOptions',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}/available-fulfillment-options',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAvailableFulfillmentOptions.fromReq = fromReq;
    __listAvailableFulfillmentOptions.__isAmbassador = true;
    return __listAvailableFulfillmentOptions;
}
/**
 * Retrieves a list of available time slots for each fulfillment type.
 *
 * Each time slot is the first available time slot for the given fulfillment type.
 */
export function listFirstAvailableTimeSlotForFulfillmentTypes(payload) {
    var _a = serializer(_listFirstAvailableTimeSlotForFulfillmentTypesRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFirstAvailableTimeSlotForFulfillmentTypesResponse, { _address: _address, _addressLocation: _addressLocation, _fulfillmentAddress: _fulfillmentAddress, _fulfillmentTimeSlot: _fulfillmentTimeSlot }).fromJSON;
    function __listFirstAvailableTimeSlotForFulfillmentTypes(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListFirstAvailableTimeSlotForFulfillmentTypes',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}/first-available-time-slot-for-fulfillment-types',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFirstAvailableTimeSlotForFulfillmentTypes.fromReq = fromReq;
    __listFirstAvailableTimeSlotForFulfillmentTypes.__isAmbassador = true;
    return __listFirstAvailableTimeSlotForFulfillmentTypes;
}
/**
 * Retrieves a list of available time slots for each fulfillment type.
 *
 * Each time slot is the first available time slot for the given fulfillment type.
 */
export function listFirstAvailableTimeSlotsForOperations(payload) {
    var _a = serializer(_listFirstAvailableTimeSlotsForOperationsRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFirstAvailableTimeSlotsForOperationsResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _fulfillmentAddress: _fulfillmentAddress,
        _fulfillmentTimeSlot: _fulfillmentTimeSlot,
        _operationTimeSlot: _operationTimeSlot,
    }).fromJSON;
    function __listFirstAvailableTimeSlotsForOperations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'POST',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListFirstAvailableTimeSlotsForOperations',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/first-available-time-slots-for-operations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFirstAvailableTimeSlotsForOperations.fromReq = fromReq;
    __listFirstAvailableTimeSlotsForOperations.__isAmbassador = true;
    return __listFirstAvailableTimeSlotsForOperations;
}
/** For each menu, retrieves the first available time slots for each fulfillment type. */
export function listFirstAvailableTimeSlotsForMenus(payload) {
    var _a = serializer(_listFirstAvailableTimeSlotsForMenusRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listFirstAvailableTimeSlotsForMenusResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _firstFulfillmentTimeSlotsPerMenu: _firstFulfillmentTimeSlotsPerMenu,
        _fulfillmentAddress: _fulfillmentAddress,
        _fulfillmentTimeSlot: _fulfillmentTimeSlot,
    }).fromJSON;
    function __listFirstAvailableTimeSlotsForMenus(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListFirstAvailableTimeSlotsForMenus',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}/first-available-time-slots-for-menus',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listFirstAvailableTimeSlotsForMenus.fromReq = fromReq;
    __listFirstAvailableTimeSlotsForMenus.__isAmbassador = true;
    return __listFirstAvailableTimeSlotsForMenus;
}
/** Retrieves a list of the available time slots for a given date. */
export function listAvailableTimeSlotsForDate(payload) {
    var _a = serializer(_listAvailableTimeSlotsForDateRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAvailableTimeSlotsForDateResponse, { _address: _address, _addressLocation: _addressLocation, _fulfillmentAddress: _fulfillmentAddress, _fulfillmentTimeSlot: _fulfillmentTimeSlot }).fromJSON;
    function __listAvailableTimeSlotsForDate(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListAvailableTimeSlotsForDate',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}/available-time-slots-for-date',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAvailableTimeSlotsForDate.fromReq = fromReq;
    __listAvailableTimeSlotsForDate.__isAmbassador = true;
    return __listAvailableTimeSlotsForDate;
}
/**
 * Retrieves a list of the available dates in a given time range.
 *
 * A date is considered available if it has at least one available time slot.
 */
export function listAvailableDatesInRange(payload) {
    var _a = serializer(_listAvailableDatesInRangeRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAvailableDatesInRangeResponse, {}).fromJSON;
    function __listAvailableDatesInRange(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ListAvailableDatesInRange',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}/available-dates-in-range',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAvailableDatesInRange.fromReq = fromReq;
    __listAvailableDatesInRange.__isAmbassador = true;
    return __listAvailableDatesInRange;
}
/**
 * Retrieves a list of the fulfillment options that will be available given the provided filters.
 *
 * TODO: probably rename, the implementation took a different direction than the name suggests
 */
export function getExpectedFulfillmentSelection(payload) {
    var _a = serializer(_getExpectedFulfillmentSelectionRequest, { _address: _address, _addressLocation: _addressLocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getExpectedFulfillmentSelectionResponse, {
        _address: _address,
        _addressLocation: _addressLocation,
        _availabilityException: _availabilityException,
        _fulfillmentOption: _fulfillmentOption,
        _fulfillmentOptionAvailability: _fulfillmentOptionAvailability,
        _pickupDetails: _pickupDetails,
    }).fromJSON;
    function __getExpectedFulfillmentSelection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.GetExpectedFulfillmentSelection',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}/expected-fulfillment-selection',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getExpectedFulfillmentSelection.fromReq = fromReq;
    __getExpectedFulfillmentSelection.__isAmbassador = true;
    return __getExpectedFulfillmentSelection;
}
/**
 * Validates an operation's address
 *
 * Checks if the address linked to the operation (stored in business_location_details) is valid.
 * An address is considered valid if it has:
 * 1. A non-empty formatted address
 * 2. Valid geocode coordinates (not 0,0)
 * 3. A non-empty country field
 *
 * If the address is invalid, the response includes specific violations.
 */
export function validateOperationAddress(payload) {
    var _a = serializer(_validateOperationAddressRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_validateOperationAddressResponse, {}).fromJSON;
    function __validateOperationAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'GET',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.ValidateOperationAddress',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/operations/{operationId}/validate-address',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __validateOperationAddress.fromReq = fromReq;
    __validateOperationAddress.__isAmbassador = true;
    return __validateOperationAddress;
}
/**
 * Synchronously update tags on multiple Operations, by list of operation ids
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateOperationTags(payload) {
    var _a = serializer(_bulkUpdateOperationTagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateOperationTagsResponse, {}).fromJSON;
    function __bulkUpdateOperationTags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'POST',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.BulkUpdateOperationTags',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/bulk/operations/update-tags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateOperationTags.fromReq = fromReq;
    __bulkUpdateOperationTags.__isAmbassador = true;
    return __bulkUpdateOperationTags;
}
/**
 * Asynchronously update tags on multiple Operations, by provided filter
 * An empty filter will update all Operations
 * A tag that appears both in the list of assign and unassign tags, will be assigned
 */
export function bulkUpdateOperationTagsByFilter(payload) {
    var _a = serializer(_bulkUpdateOperationTagsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateOperationTagsByFilterResponse, {}).fromJSON;
    function __bulkUpdateOperationTagsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.operations.v1.operation',
            method: 'POST',
            methodFqn: 'wix.restaurants.operations.v1.OperationsService.BulkUpdateOperationTagsByFilter',
            url: resolveWixRestaurantsOperationsV1OperationsServiceUrl({
                protoPath: '/v1/bulk/operations/update-tags-by-filter',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateOperationTagsByFilter.fromReq = fromReq;
    __bulkUpdateOperationTagsByFilter.__isAmbassador = true;
    return __bulkUpdateOperationTagsByFilter;
}
//# sourceMappingURL=http.impl.js.map